import React, { useRef } from 'react'
import './Wrap.css'
import { motion, useScroll, useTransform } from 'framer-motion'
import useDimension from '../Extra/dimension';

const WrapTest = () => {
    const wrapper = useRef(null);
    const { height } = useDimension();
    const allImages = [
        "img1.png",
        "img2.png",
        "img3.png",
        "img4.png",
        "img5.png",
        "img6.png",
        "img7.png",
        "img8.png",
        "img9.png",
        "img10.png",
        "img11.png",
        "img12.png",
    ]

    const { scrollYProgress } = useScroll({
        target: wrapper,
        offset: ["start end", "end start"]
    })

    const y = useTransform(scrollYProgress, [0, 1], [0, height*2])
    const y2 = useTransform(scrollYProgress, [0, 1], [0, height * 3.3])
    const y3 = useTransform(scrollYProgress, [0, 1], [0, height * 1.25])
    const y4 = useTransform(scrollYProgress, [0, 1], [0, height * 3])

    const Column = ({ images,y=0 }) => {
        return (
            <motion.div 
            style={{y}}
            className="column">
                {
                    images.map((image, index) => (
                        <div className="imageContainer" key={index}>
                            <img src={`/swiper/${image}`} alt='projectImg' fill="true" />
                        </div>
                    ))
                }
            </motion.div>
        )
    }

    return (
        <motion.div className='wrapper' ref={wrapper} >
            <Column images={[allImages[0], allImages[1], allImages[2]]} y={y}/>
            <Column images={[allImages[3], allImages[4], allImages[5]]} y={y2}/>
            <Column images={[allImages[6], allImages[7], allImages[8]]} y={y3}/>
            <Column images={[allImages[11], allImages[9], allImages[10]]} y={y4}/>

        </motion.div>
    )
}

export default WrapTest